import { useStaticQuery, graphql } from "gatsby";
import { HighPopulationCovidCasesQuery } from "../../../graphql-types";

export const useHighPopulationCovidCases = () => {
  const highPopulationCovidCasesData = useStaticQuery<
    HighPopulationCovidCasesQuery
  >(graphql`
    query HighPopulationCovidCases {
      askAboutQuery {
        covidCaseSelectedCountries {
          iso2
          alias
          displayName
          population
          latest {
            date
            totalCases
            totalCasesPerMillion
            totalDeaths
            averageNewCases
            infectionRate
            testsPerCase
          }
          data {
            date
            averageNewCases
            infectionRate
            testsPerCase
          }
        }
      }
    }
  `);

  return highPopulationCovidCasesData.askAboutQuery.covidCaseSelectedCountries;
};
